<template>
  <div>
    <h1>EXSBOwner List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <span v-if="view">
      <pagination
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </span>

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>createdAt</th>
            <th>updatedAt</th>
            <th>deletedAt</th>
            <th>createdBy</th>
            <th>updatedBy</th>
            <th>deletedBy</th>
            <th>state</th>
            <th>titlePartOne</th>
            <th>titlePartTwo</th>
            <th>contactPerson</th>
            <th>representativePerson</th>
            <th>nip</th>
            <th>phone</th>
            <th>mobilePhone</th>
            <th>userEmail</th>
            <th>street</th>
            <th>city</th>
            <th>postcode</th>
            <th>province</th>
            <th>country</th>
            <th>extraInfo</th>
            <th>bankName</th>
            <th>bankAccount</th>
            <th>smsKey</th>
            <th>logo</th>
            <th>ownerType</th>
            <th>onBehalfStatus</th>
            <th>onBehalfEmail</th>
            <th>replyToEmail</th>
            <th>longitude</th>
            <th>latitude</th>
            <th colspan="2" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['@id'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['createdAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['updatedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['deletedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['createdBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['updatedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['deletedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['state'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['titlePartOne'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['titlePartTwo'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['contactPerson'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['representativePerson'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['nip'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['phone'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['mobilePhone'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['userEmail'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['street'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['city'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['postcode'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['province'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['country'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['extraInfo'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['bankName'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['bankAccount'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['smsKey'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['logo'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['ownerType'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['onBehalfStatus'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['onBehalfEmail'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['replyToEmail'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['longitude'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                {{ item['latitude'] }}
              </router-link>
            </td>
            <td>
              <router-link
                :to="{name: 'EXSBOwnerShow', params: { id: item['@id'] }}">
                <span
                  class="fa fa-search"
                  aria-hidden="true" />
                <span class="sr-only">Show</span>
              </router-link>
            </td>
            <td>
              <router-link :to="{name: 'EXSBOwnerUpdate', params: { id: item['@id'] }}">
                <span
                  class="fa fa-pencil"
                  aria-hidden="true" />
                <span class="sr-only">Edit</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'EXSBOwnerCreate' }"
      class="btn btn-primary">Create</router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'exsbowner/del/deleted',
    error: 'exsbowner/list/error',
    items: 'exsbowner/list/items',
    isLoading: 'exsbowner/list/isLoading',
    view: 'exsbowner/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbowner/list/default'
  })
}
</script>
